import { DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { TaskReadOnlyView } from "routes/component-library/explorer/components/task-read-only-view"

export function ComponentDetailsDialog({ task }) {
    const { cancel } = useBoundContext()
    const component = normalizeComponentTask(task)

    return (
        <Stack sx={{ overflow: "hidden" }}>
            <DialogTitle
                data-cy="component-details-dialog-title"
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
            >
                <Typography variant="h6">Component details</Typography>
                <IconButton onClick={cancel} data-cy="close-component-details">
                    <Iconify icon="eva:close-fill" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TaskReadOnlyView task={component} />
            </DialogContent>
        </Stack>
    )
}

function normalizeComponentTask(task = {}) {
    const period = task?.frequency?.period
    const frequencyCode = task?.frequencyCode ?? `${task?.frequency?.interval ?? ""}${period?.[0] ?? ""}`

    return {
        ...task,
        heading: task?.heading ?? task?.title,
        frequencyCode,
        timing: task?.timing ?? { minutes: task?.minutes },
        actionsHtml: task?.actionsHtml ?? task?.content,
        notesHtml: task?.notesHtml ?? task?.note,
    }
}
